import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { removeMarker, setMarkers } from '../../../redux/markers/Actions';

import {
    Marker
} from 'react-mapbox-gl';

import RoomIcon from '@material-ui/icons/RoomTwoTone';
import {
    withStyles
} from '@material-ui/core/styles';

import {
    LocationPin
} from '../Icons';



class Markers extends React.Component {
    timeoutHandler = {};
    constructor (props) {
        super(props);

        this.removeMarker = this.removeMarker.bind(this);
    }

    removeMarker (markerId) {
        const { markers, dispatchSetMarkers, dispatchRemoveMarker } = this.props;
        dispatchRemoveMarker(markerId);
    }

    render () {
        const { classes, markers } = this.props;
        return markers.map((marker, i) => {
            if (this.timeoutHandler[marker.id]) {
                clearTimeout(this.timeoutHandler[marker.id]);
            }
            this.timeoutHandler[marker.id] = setTimeout(() => this.removeMarker(marker.id), 10000);
            return (
                <Marker
                    key={i}
                    coordinates={marker.location}
                    anchor="bottom"
                >
                    <LocationPin
                        onClick={() => this.removeMarker(marker.id)}
                        className={classes.pin}
                    />
                </Marker>
            ); 
});
    }
}

const mapStateToProps = (state) => ({
    markers: state.markers
});

const mapDispatchToProps = (dispatch) => ({
    dispatchSetMarkers: (markers) => dispatch(setMarkers(markers)),
    dispatchRemoveMarker: (id) => dispatch(removeMarker(id))
});

const styles = (theme) => ({
    pin: {
        cursor: 'pointer'
        // fontSize: '50px',
        // '& > path:first-child': {
        //     fill: theme.palette.primary.light,
        //     opacity: 1
        // },
        // '& > path:nth-child(2)': {
        //     fill: theme.palette.primary.contrastText,
        //     opacity: 1
        // },
        // '& > circle': {
        //     opacity: 0
        // }
    }
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles)
)(Markers);